import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21ce94b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PaneBuildingPart CustomScrollbar" }
const _hoisted_2 = { class: "PaneIntro" }
const _hoisted_3 = {
  key: 0,
  class: "List"
}
const _hoisted_4 = { class: "FeaturedTitleLine" }
const _hoisted_5 = { class: "Label" }
const _hoisted_6 = { class: "FeaturedResaleItems" }
const _hoisted_7 = { class: "List" }
const _hoisted_8 = { class: "ListLabels PaneLine Disabled" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = { class: "Label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_12 = { class: "Label" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_14 = { class: "ListContent CustomScrollbar" }
const _hoisted_15 = { class: "Note" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaneTitle = _resolveComponent("PaneTitle")!
  const _component_FeaturedOnlineType = _resolveComponent("FeaturedOnlineType")!
  const _component_PaneLink = _resolveComponent("PaneLink")!
  const _component_PaneLineOnlineType = _resolveComponent("PaneLineOnlineType")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PaneTitle, { paneID: _ctx.id }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.title) + " (" + _toDisplayString(_ctx.onlineTypes.length) + ")", 1)
      ]),
      _: 1
    }, 8, ["paneID"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('LIST_OF_ALL_MATERIALS_IN_THIS_BUILDING_PART')), 1)
    ]),
    (_ctx.isResale)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.onlineTypes.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.mixWB('ALL')) + " (" + _toDisplayString(_ctx.onlineTypes.length) + ")", 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlineTypes, (oType) => {
                    return (_openBlock(), _createBlock(_component_PaneLink, {
                      key: oType.resaleID,
                      "pane-id": oType.resaleID
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FeaturedOnlineType, { "online-type": oType }, null, 8, ["online-type"])
                      ]),
                      _: 2
                    }, 1032, ["pane-id"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.mixWB('TYPE')), 1),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.mixWB('WEIGHT')), 1),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlineTypes, (oType) => {
                return (_openBlock(), _createBlock(_component_PaneLink, {
                  key: oType.hashID,
                  class: _normalizeClass(["PaneLine", { 'InResaleContext': _ctx.isResale }]),
                  "pane-id": oType.hashID
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PaneLineOnlineType, { "online-type": oType }, null, 8, ["online-type"])
                  ]),
                  _: 2
                }, 1032, ["class", "pane-id"]))
              }), 128))
            ])
          ]),
          _createElementVNode("span", _hoisted_15, "* " + _toDisplayString(_ctx.mixWB('MISSING_CALCULATIONS')), 1)
        ], 64))
  ]))
}